import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import CustomButton from "../../../core/components/ui/CustomButton"
import { useNavigate } from "react-router-dom";
import { Box, FormControl, InputLabel, MenuItem, Paper, Select, Stack, CircularProgress } from "@mui/material";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import { useEffect, useState } from "react";
import CustomTextField from "../../../core/components/ui/CustomTextfield";
import { useGates } from "../hooks/useGates";
import { useSnackbar } from "notistack";
import { PortsDropdown } from "../../PortPlugin";

const CreateGatePage = () => {

    const [portUID, setPortUID] = useState(null);
    const [gateType, setGateType] = useState('IN');
    const [gateName, setGateName] = useState(null)
    const [gateLocation, setGateLocation] = useState(null)

    const {isLoadingCreateGate, createdGate, errorCreateGate, createGate} = useGates()

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        console.log("portUID bb", portUID);
    }, [portUID])

    useEffect(() => {
        if (createdGate) {
            enqueueSnackbar("Successfully created gate.", {
                variant: "success",
                autoHideDuration: 3000
            });
            navigate('/gates')
        }
    }, [createdGate])

    useEffect(() => {
            if (errorCreateGate) {
                let err_msg = errorCreateGate?.error || errorCreateGate?.message || "Something went wrong."
                enqueueSnackbar(err_msg, {
                    variant: "error",
                    autoHideDuration: 3000
                });
            }
        }, [JSON.stringify(errorCreateGate)])

    const handleChangeGateType = (e) => {
        setGateType(e.target.value);
    };

    const handleOnChangeGateName = (e) => {
        setGateName(e.target.value);
    }

    const handleOnChangeGateLocation = (e) => {
        setGateLocation(e.target.value);
    }

    const handleSubmit = () => {
        createGate(portUID, gateType, "Active", gateName, gateLocation)
    }

    const handleOnChangePortsDropdown = (value) => {
        setPortUID(value.portUid)
    }


    return(
        <>
            <CustomButton 
                variant="text" 
                startIcon={<ArrowBackIcon fontSize="small" />}
                label="Back to Gate List"
                customStyles={{fontSize: 14, ml: -2}}
                onClick={() => navigate("/gates")}
            />

            <Box sx={{m: "auto", maxWidth: "1000px"}}>  
                <Box sx={{textAlign: "start", mt: 2}}>
                    <CustomTypography 
                        variant="h3"
                        text={"Create New Gate"}
                        customStyles={{
                            marginBottom: 0, 
                        }}
                    />

                    <CustomTypography 
                        variant="subtitle1"
                        text={"Add new gate"}
                        customStyles={{
                            marginBottom: 0, 
                        }}
                    />
                </Box>

                <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px 40px", mt: 3}}>
                    <Box sx={{textAlign: "start", mb: 5}}>
                        <CustomTypography 
                            variant="h3"
                            text={"Gate Details"}
                            customStyles={{
                                marginBottom: 0, 
                                fontSize: 22,
                                fontWeight: 600
                            }}
                        />

                        <CustomTypography 
                            variant="caption"
                            text={"Fill in the details to create a new gate"}
                            customStyles={{
                                marginBottom: 0,
                                fontSize: 14 
                            }}
                        />
                    </Box>

                    <Stack direction="row" spacing={4} sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}>
                        <Box flex={1}>
                            <CustomTypography 
                                variant="subtitle2"
                                text={"Port"}
                                customStyles={{
                                    marginBottom: 1, 
                                }}
                            />
                            <PortsDropdown onChange={handleOnChangePortsDropdown} />
                        </Box>
                        <Box flex={1}>
                            <CustomTypography 
                                variant="subtitle2"
                                text={"Gate Type"}
                                customStyles={{
                                    marginBottom: 1, 
                                }}
                            />
                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small" fullWidth>
                            <InputLabel id="demo-select-small-label">Gate Type</InputLabel>
                            <Select
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={gateType}
                                label="Gate Type"
                                onChange={handleChangeGateType}
                            >
                                <MenuItem value={"IN"}>IN</MenuItem>
                                <MenuItem value={"OUT"}>OUT</MenuItem>
                            </Select>
                            </FormControl>
                        </Box>
                    </Stack>   

                    <Stack direction="row" spacing={4} sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}>
                        <Box flex={1}>
                            <CustomTypography 
                                variant="subtitle2"
                                text={"Gate Name"}
                                customStyles={{
                                    marginBottom: 1, 
                                }}
                            />
                            <CustomTextField 
                                placeholder={"Enter gate name"}
                                variant={"outlined"}
                                value={gateName}
                                onChange={handleOnChangeGateName}
                                fullWidth={true}
                                multiline={false}
                                allowedPattern={/[^a-zA-Z0-9\s]/g}
                                hiddenLabel
                                inputProps={{maxLength: 11}}
                            />
                        </Box>
                        <Box flex={1}>
                            <CustomTypography 
                                variant="subtitle2"
                                text={"Location"}
                                customStyles={{
                                    marginBottom: 1, 
                                }}
                            />
                            <CustomTextField 
                                placeholder={"Enter location"}
                                variant={"outlined"}
                                value={gateLocation}
                                onChange={handleOnChangeGateLocation}
                                fullWidth={true}
                                allowedPattern={/[^a-zA-Z0-9\s,.'\-\n]/gi}
                                multiline={false}
                                hiddenLabel
                            />
                        </Box>
                    </Stack>

                    <Stack direction="row" spacing={4} sx={{
                            justifyContent: "end",
                            alignItems: "center",
                            mt: 7
                        }}>
                        <CustomButton 
                            variant={"outlined"}
                            label={"Cancel"}
                            customStyles={{}}
                            onClick={() => navigate("/gates")}
                        />     

                        <CustomButton 
                            variant={"contained"}
                            label={"Submit Request"}
                            disabled={isLoadingCreateGate}
                            startIcon={isLoadingCreateGate && <CircularProgress size="15px" color="#fff" sx={{mr: "2px"}} />}
                            customStyles={{
                                opacity: (portUID && gateType && gateName && gateLocation && !isLoadingCreateGate) ? "100%" : "55%",
                                cursor: (portUID && gateType && gateName && gateLocation && !isLoadingCreateGate) ? "pointer" : "not-allowed !important",
                            }}
                            onClick={
                                (portUID && gateType && gateName && gateLocation && !isLoadingCreateGate) ? handleSubmit : null
                            }
                        />    
                    </Stack>
                </Paper>
            </Box>
        </>
    )
}

export default CreateGatePage